import { JsonSchemaInfoBasePropertiesFormProperties } from "../models/audit-event.model";

export class AuditInfoBaseForm{
  name: string;
  valid: boolean;
  schema: JsonSchemaInfoBasePropertiesFormProperties;
}



// WEBPACK FOOTER //
// ./src/app/views/audit/models/audit-info-base.model.ts